import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

import Register from './views/Register';
import Login from './views/Login';
import AccountVerify from './views/AccountVerify';
import RecoverPassword from './views/RecoverPassword';
import Dashboard from './views/Dashboard';

import Cadastre from './components/cadastre/Cadastre';
import PersonalData from './views/PersonalData';

import Dependents from './components/dependents/Dependents';
import DependentsCadastre from './views/DependentsCadastre';
import DependentsList from './views/DependentsList';

import Covenants from './components/covenants/Covenants';
import CovenantCadastre from './views/CovenantCadastre';
import CovenantsList from './views/CovenantsList';

import Addresses from './components/addresses/Addresses';
import AddressCadastre from './views/AddressCadastre';
import AddressesList from './views/AddressesList';

import Professionals from './components/professionals/Professionals';
import ProfessionalsList from './views/ProfessionalsList';

import MySchedule from './components/mySchedules/MySchedule';
import MyScheduleList from './views/MyScheduleList';

import Calendar from './components/calendars/Calendar';
import CalendarFilter from './views/CalendarFilter';
import CalendarSearch from './views/CalendarSearch';
import CalendarView from './views/CalendarView';

import Schedule from './components/schedule/Schedule';
import ScheduleConfirmation from './views/ScheduleConfirmation';
import ScheduleSuccess from './views/ScheduleSuccess';
import PreSchedule from './views/PreSchedule';

import Payment from './components/payment/Payment';
import PaymentProcess from './views/PaymentProcess';
import PaymentCancel from './views/PaymentCancel';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Dashboard,
    //   meta: { requiresAuth: true },
    //   redirect: { name: 'dashboard' },
    // },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: { requiresAuth: false, desc: 'Crie sua conta' },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false, desc: 'Login' },
    },
    {
      path: '/verify',
      name: 'verify',
      component: AccountVerify,
      meta: { requiresAuth: false, desc: 'Verificação' },
    },
    {
      path: '/recover-password',
      name: 'recover-password',
      component: RecoverPassword,
      meta: { requiresAuth: false, desc: 'Recuperar senha' },
    },
    {
      path: '/',
      name: 'home',
      component: Dashboard,
      meta: { requiresAuth: true, desc: 'Dashboard' },
    },
    {
      path: '/patient',
      name: 'patient',
      component: Cadastre,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/patient/cadastre',
          name: 'patient-cadastre',
          component: PersonalData,
          meta: { requiresAuth: true, desc: 'Dados Pessoais' },
        },
      ],
    },
    {
      path: '/dependents',
      name: 'dependents',
      component: Dependents,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/dependents/list',
          name: 'dependents-list',
          component: DependentsList,
          meta: { requiresAuth: true, desc: 'Dependentes' },
        },
        {
          path: '/dependents/:id?',
          name: 'dependents-cadastre',
          component: DependentsCadastre,
          meta: { requiresAuth: true, desc: 'Dependente' },
          props: true,
        },
      ],
    },
    {
      path: '/covenants',
      name: 'covenants',
      component: Covenants,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/covenants/list',
          name: 'covenants-list',
          component: CovenantsList,
          meta: { requiresAuth: true, desc: 'Convênios' },
        },
        {
          path: '/covenants/:id?',
          name: 'covenants-cadastre',
          component: CovenantCadastre,
          meta: { requiresAuth: true, desc: 'Convênio' },
          props: true,
        },
      ],
    },
    {
      path: '/addresses',
      name: 'addresses',
      component: Addresses,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/addresses/list',
          name: 'addresses-list',
          component: AddressesList,
          meta: { requiresAuth: true, desc: 'Endereços' },
        },
        {
          path: '/addresses/:id?',
          name: 'addresses-cadastre',
          component: AddressCadastre,
          meta: { requiresAuth: true, desc: 'Endereço' },
          props: true,
        },
      ],
    },
    {
      path: '/professionals',
      name: 'professionals',
      component: Professionals,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/professionals/list',
          name: 'professionals-list',
          component: ProfessionalsList,
          meta: { requiresAuth: true, desc: 'Meus Médicos' },
        },
      ],
    },
    {
      path: '/my-schedule',
      name: 'my-schedule',
      component: MySchedule,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/my-schedule/list',
          name: 'my-schedule-list',
          component: MyScheduleList,
          meta: { requiresAuth: true, desc: 'Meus Agendamentos' },
        },
        // {
        //   path: '/my-schedule/:id/view',
        //   name: 'my-schedule-view',
        //   component: ScheduleView,
        //   meta: { requiresAuth: true, desc: 'Agenda' },
        // },
      ],
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/calendar/filter',
          name: 'calendar-filter',
          component: CalendarFilter,
          meta: { requiresAuth: true, desc: 'Busca' },
        },
        {
          path: '/calendar/search',
          name: 'calendar-search',
          component: CalendarSearch,
          meta: { requiresAuth: true, desc: 'Agendas' },
        },
        {
          path: '/calendar/:id/view',
          name: 'calendar-view',
          component: CalendarView,
          meta: { requiresAuth: true, desc: 'Agenda' },
        },
      ],
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/schedule/confirmation',
          name: 'schedule-confirmation',
          component: ScheduleConfirmation,
          meta: { requiresAuth: true, desc: 'Agendamento' },
        },
        {
          path: '/schedule/success',
          name: 'schedule-success',
          component: ScheduleSuccess,
          meta: { requiresAuth: true, desc: 'Agendamento' },
        },
        {
          path: '/schedule/pre-schedule',
          name: 'pre-schedule',
          component: PreSchedule,
          meta: { requiresAuth: true, desc: 'Agendamento' },
        },
      ],
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/payment/process',
          name: 'payment-process',
          component: PaymentProcess,
          meta: { requiresAuth: true, desc: 'Pagamento' },
        },
        {
          path: '/payment/cancel',
          name: 'payment-cancel',
          component: PaymentCancel,
          meta: { requiresAuth: true, desc: 'Pagamento' },
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let isAuthenticated = store.getters['auth/isAuthenticated'];
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  const { ps } = to.query;
  if (ps) {
    localStorage.setItem('mbpps', ps);
  }

  if (isAuthenticated) {
    if (!requiresAuth) {
      next({ path: '/' });
    } else {
      next();
    }
  } else if (requiresAuth) {
    // try renew token
    await store.dispatch('auth/renew').catch((err) => {
      if (err.response.data.message === 'Token inválido') {
        next({ path: '/login', query: to.query });
      }
    });

    isAuthenticated = store.getters['auth/isAuthenticated'];

    if (isAuthenticated) {
      next();
    } else {
      next({ path: '/login', query: to.query });
    }
  } else {
    next();
  }
});

export default router;
